import React from "react";
import GradientGlowDivider from "../../../../Components/GradientGlowDivider.js";
import CaseStudyCard from "./Components/CaseStudyCard.js";
import CaseStudyBasicCard from "./Components/CaseStudyBasicCard.js";
import CaseStudyDetailCard from "./Components/CaseStudyDetailCard.js";

const CaseStudyInitialSection = ({ data }) => {
  return (
    <section className="relative mb-12">
      <div className="flex flex-col">
        <CaseStudyCard
          title={data.title}
          description={data.description}
          subDescription={data.subDescription}
          imageUrl={data.imageUrl}
          pointList={data.pointList}
          imageClassName={data.imageClassName}
        />
        <div className="w-[90%] mx-auto">
          <GradientGlowDivider />
        </div>

        {data.detailedDescription && (
          <div className="flex flex-col items-center justify-center text-start md:w-[76%] px-4 md:px-32 pt-20 md:pt-32">
            <h1 className="font-normal md:text-[20px] leading-[145%] tracking-[0%]">
              {data.detailedDescription}
            </h1>
          </div>
        )}
      </div>
      <CaseStudyBasicCard
        title={
          <div>
            What was the
            <span className="font-bold text-white"> Challenge?</span>
          </div>
        }
        description={data.challenge}
      />
      <CaseStudyDetailCard
        imageURL={data.solutionImage}
        title={
          <div>
            {data.firstSectionTitle ? data.firstSectionTitle : "Building the"}
            <span className="font-bold text-white">
              {data.firstSectionDesc ? data.firstSectionDesc : " Solution"}
            </span>
          </div>
        }
        description={data.solution}
      />
      <div className="h-32 md:h-40"></div>
      <CaseStudyDetailCard
        imageURL={data.approachImage}
        title={
          <div>
            {data.secondSectionTitle ? data.secondSectionTitle : "Our"}
            <span className="font-bold text-white">
              {data.secondSectionDesc
                ? data.secondSectionDesc
                : " Solution in Action"}
            </span>
          </div>
        }
        description={data.approach}
      />
      <CaseStudyBasicCard
        className="pt-40"
        titleWidth={data.thirdSectionTitleWidth}
        boxClassName={data.thirdSectionClassName}
        title={
          <div>
            {data.thirdSectionTitle ? data.thirdSectionTitle : "The"}
            <span className="font-bold text-white">
              {data.thirdSectionDesc
                ? data.thirdSectionDesc
                : " Difference We Made"}
            </span>
          </div>
        }
        description={data.impact}
        subDescription={data.subImpact}
      />
    </section>
  );
};

export default CaseStudyInitialSection;
